export default __webpack_public_path__ + "media/images/images/gallery/37-7864c23e73a04fcc1949bb1ffbdfaedb.png";